/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_InvestmentInputs */

const en_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment`)
};

const es_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inversión`)
};

const fr_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investissement`)
};

const de_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapitalanlage`)
};

const ja_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投資用`)
};

const zh_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投资性`)
};

const ar_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استثماري`)
};

const id_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investasi`)
};

const it_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A uso Investimento`)
};

const ru_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инвестиционная`)
};

const pt_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investimento`)
};

const ko_val_investment = /** @type {(inputs: Val_InvestmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`투자용`)
};

/**
* | output |
* | --- |
* | "Investment" |
*
* @param {Val_InvestmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_investment = /** @type {((inputs?: Val_InvestmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_InvestmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_investment(inputs)
	if (locale === "es") return es_val_investment(inputs)
	if (locale === "fr") return fr_val_investment(inputs)
	if (locale === "de") return de_val_investment(inputs)
	if (locale === "ja") return ja_val_investment(inputs)
	if (locale === "zh") return zh_val_investment(inputs)
	if (locale === "ar") return ar_val_investment(inputs)
	if (locale === "id") return id_val_investment(inputs)
	if (locale === "it") return it_val_investment(inputs)
	if (locale === "ru") return ru_val_investment(inputs)
	if (locale === "pt") return pt_val_investment(inputs)
	return ko_val_investment(inputs)
});